import { useId } from "react";

type Props = {
  startColor: string;
  endColor: string;
};

export default function IconPhoto({ startColor, endColor }: Props) {
  const gradientId = useId();

  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 8.66673H16.2608M3.25 17.3333L8.66667 11.9167C9.672 10.9493 10.9113 10.9493 11.9167 11.9167L17.3333 17.3333M15.1667 15.1667L16.25 14.0834C17.2553 13.116 18.4947 13.116 19.5 14.0834L22.75 17.3334M3.25 6.5C3.25 5.63805 3.59241 4.8114 4.2019 4.2019C4.8114 3.59241 5.63805 3.25 6.5 3.25H19.5C20.362 3.25 21.1886 3.59241 21.7981 4.2019C22.4076 4.8114 22.75 5.63805 22.75 6.5V19.5C22.75 20.362 22.4076 21.1886 21.7981 21.7981C21.1886 22.4076 20.362 22.75 19.5 22.75H6.5C5.63805 22.75 4.8114 22.4076 4.2019 21.7981C3.59241 21.1886 3.25 20.362 3.25 19.5V6.5Z"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="3.25"
          y1="3.25"
          x2="22.75"
          y2="22.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={startColor} />
          <stop offset="1" stopColor={endColor} />
        </linearGradient>
      </defs>
    </svg>
  );
}
